import React from 'react';

const SkeletonBlock = ({ className = '' }) => (
  <div className={`animate-pulse rounded-2xl bg-slate-200/80 dark:bg-slate-800/80 ${className}`} />
);

export const PublicTemplateSkeleton = ({ count = 4, variant = 'default' }) => {
  const isMinimal = variant === 'minimal' || variant === 'catalog';
  const isCatalog = variant === 'catalog';

  return Array.from({ length: count }).map((_, index) => (
    <article
      key={`public-template-skeleton-${index}`}
      className={
        isMinimal
          ? 'overflow-hidden rounded-xl border border-border/80 bg-panel-strong/50'
          : 'glass-panel overflow-hidden rounded-[1.35rem] border border-border/80 bg-white/75 dark:bg-slate-950/20'
      }
    >
      <SkeletonBlock
        className={
          isMinimal ? 'aspect-[16/10] w-full rounded-none' : 'aspect-[16/10] w-full rounded-none'
        }
      />
      <div className={isMinimal ? 'space-y-2.5 p-3' : 'space-y-3 p-4'}>
        <SkeletonBlock className={isMinimal ? 'h-3.5 w-4/5' : 'h-4 w-3/4'} />
        <div className="flex items-center justify-between gap-2">
          <SkeletonBlock className={isMinimal ? 'h-3 w-16' : 'h-3 w-24'} />
          <SkeletonBlock className="h-3 w-10" />
        </div>
        {!isMinimal ? <SkeletonBlock className="h-3 w-full" /> : null}
      </div>
    </article>
  ));
};
